import { Stack } from '@mui/material';
import { ScreenWrap, HeaderBreadcrumbs, SoloLoading } from '../../components';
import UserClassificationForm from './UserClassificationForm';
import { useParams } from 'react-router';
import { Api } from '../../api';

export default function EditUserClassificationScreen() {
  const { id } = useParams();
  const api = Api.ClientClassification.useReadItem(id!);
  if (!api.data) return <SoloLoading />;

  return (
    <ScreenWrap>
      <Stack spacing={3}>
        <HeaderBreadcrumbs
          title="Edit User Classification"
          items={[
            {
              name: 'Users',
              url: '/users',
            },
            {
              name: 'User Classifications',
              url: '/user-classifications',
            },
            { name: 'Edit' },
          ]}
        />

        <UserClassificationForm existing={api.data} />
      </Stack>
    </ScreenWrap>
  );
}
